import React from 'react'


export default class extends React.Component {

  render() {
    return (
      <div className="full accent">
        <div className="wrap content-text">
          <h2 className="cta-title">Start with a free trial</h2>
          <p style={{textAlign:"center", opacity:".8"}}>Use all features for free with the 50-contact trial, you only need an email address to get started.</p>
          <div style={{textAlign:"center"}}><button onClick={() => this.props.openModal("register")} className="btn btn-f btn-fat">Try it FREE</button></div>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/StartFooterCTA.js